export const isReactCompilerEnabled = () => {
  return !!window.sessionStorage.getItem('reactCompilerEnabled');
};
